const facetsContainer = document.querySelector('.facets-container');
const collectionWrapper = document.querySelector('.collection-wrapper');
if (!facetsContainer) return;


let facetsHeight = getComputedStyle(facetsContainer).height;
let threshold = +(+facetsContainer?.getBoundingClientRect().bottom + +window.scrollY).toFixed(2);

function handleStickyFilter() {
  const scroll = +window.scrollY.toFixed(2);

  if (scroll > threshold) {
    collectionWrapper.style.setProperty('--facets-height', facetsHeight);
    collectionWrapper.classList.add('facets-sticky');
  } else {
    collectionWrapper.style.setProperty('--facets-height', 0);
    collectionWrapper.classList.remove('facets-sticky');
  }
}

handleStickyFilter();
window.addEventListener('scroll', handleStickyFilter);